import { require, ajax } from './require'

/**
 * 获取app列表
 */
export async function getAppLists() {
  let response = await require('GET', '/AppDownloadLists.php')
  return response
}

/**
 * 
 * @param {sid} params 
 */
export async function getCategory(params) {
  let response = await ajax('GET', '/class/Category.php', params)
  return response
}

/**
 * 添加目录
 * @param {name, level, sid} params 
 */
export async function addCategory(params) {
  let response = await ajax('POST', '/class/Category.php', params)
  return response
}

/**
 * 删除目录
 * @param {id} params 
 */
export async function delCategory(params) {
  let response = await ajax('DELETE', '/class/Category.php', params)
  return response
}

/**
 * 编辑目录
 * @param {name} params 
 */
export async function editCategory(params) {
  let response = await require('PUT', '/class/Category.php', params)
  return response
}

/**
 * 获取文章列表
 * @param {sid}} params 
 */
export async function getArticle(params) {
  let response = await ajax('GET', '/class/Article.php', params)
  return response
}

/**
 * 添加文章
 * @param {title, type, author, content, content_md, file_path, sid} params 
 */
export async function addArticle(params) {
  let response = await ajax('POST', '/class/Article.php', params)
  return response
}

/**
 * 删除文章
 * @param {id} params 
 */
export async function delArticle(params) {
  let response = await ajax('DELETE', '/class/Article.php', params)
  return response
}

/**
 * 获取产品列表
 * @param {sid}} params 
 */
export async function getProducts(params) {
  let response = await ajax('GET', '/class/Product.php', params)
  return response
}

/**
 * 添加产品
 * @param {title, subtitle, imgPath, keys, sid} params 
 */
export async function addProducts(params) {
  let response = await ajax('POST', '/class/Product.php', params)
  return response
}

/**
 * 编辑产品
 * @param {title, subtitle, imgPath, keys, sid} params 
 */
export async function editProducts(params) {
  let response = await require('PUT', '/class/Product.php', params)
  return response
}

/**
 * 删除产品
 * @param {id} params 
 */
export async function delProducts(params) {
  let response = await ajax('DELETE', '/class/Product.php', params)
  return response
}

/**
 * 获取关键字列表
 * @param {sid}} params 
 */
export async function getKeyword(params) {
  let response = await ajax('GET', '/class/Keyword.php', params)
  return response
}

/**
 * 添加关键字
 * @param {name} params 
 */
export async function addKeyword(params) {
  let response = await ajax('POST', '/class/Keyword.php', params)
  return response
}

/**
 * 删除关键字
 * @param {id} params 
 */
export async function delKeyword(params) {
  let response = await ajax('DELETE', '/class/Keyword.php', params)
  return response
}

/**
 * 管理员登录
 * @param {username, password} params 
 */
export async function login(params) {
  let response = await ajax('POST', '/class/User.php', params)
  return response
}

/**
 * 文件上传
 * @param {files[]} data 
 * @param {host+api} url 
 */
export async function uploadfile(
  data,
  url = 'http://www.lelight.cn/php/class/controller.php',
) {
  return new Promise((resolve, reject) => {
    let xhr = new XMLHttpRequest()
    xhr.open('POST', url, true)
    xhr.send(data)
    xhr.onload = function () {
      let response = JSON.parse(this.response)
      if (this.status == 200) {
        resolve(response)
      } else {
        reject('加载失败')
      }
    }
    xhr.onerror = function () {
      reject(this)
    }
  })
}
